// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-SocialLink-module--cls1--3aOTU","cls2":"contacts-SocialLink-module--cls2--tjSmp contacts-SocialLink-module--cls1--3aOTU"};